<template>
  <div class="contact-form-container">
    <form v-if="form" class="contact-form">
      <!-- <div class="row contact-form-header">
        <div class="col-12">
          <h5 class="modal-title">Potrzebujesz pomocy?</h5>
          <p>Skorzystaj z naszego formularza kontaktowego,</p>
          <p>a my skontaktujemy się z Tobą tak szybko, jak to tylko możliwe.</p>
        </div>
      </div>-->
      <div class="contact-form-header">
        <h3 class="contact-form-title">Formularz kontaktowy</h3>
      </div>

      <div class="contact-form-body">
        <div class="form-group">
          <label for="phone" class="contact-form-label">Telefon *</label>
          <input
            id="phone"
            name="phone"
            class="contact-form-input"
            type="text"
            required
            v-model="form.phone.value"
            @blur="validateField($event, form.phone)"
          />
          <span class="invalid-feedback" v-if="form.phone.errors.required">Pole nie może być puste</span>
        </div>

        <div class="form-group">
          <label for="email" class="contact-form-label">E-mail *</label>
          <input
            id="email"
            name="email"
            class="contact-form-input"
            type="email"
            required
            v-model="form.email.value"
            @blur="validateField($event, form.email)"
          />
          <span class="invalid-feedback" v-if="form.email.errors.required">Email nie może być pusty</span>
        </div>

        <div class="form-group">
          <label for="company_name" class="contact-form-label">Nazwa Zakładu Leczniczego *</label>
          <input
            id="company_name"
            name="company_name"
            class="contact-form-input"
            type="text"
            required
            v-model="form.company_name.value"
            @blur="validateField($event, form.company_name)"
          />
          <span
            class="invalid-feedback"
            v-if="form.company_name.errors.required"
          >Nazwa firmy nie może być pusta</span>
        </div>

        <div class="form-group">
          <label for="name" class="contact-form-label">Imię (opcjonalne)</label>
          <input
            id="name"
            name="name"
            class="contact-form-input"
            type="text"
            required
            v-model="form.name.value"
            @blur="validateField($event, form.name)"
          />
          <span class="invalid-feedback" v-if="form.name.errors.required">Imię nie może być puste</span>
        </div>
        <div class="form-group">
          <label for="last_name" class="contact-form-label">Nazwisko (opcjonalne)</label>
          <input
            id="last_name"
            name="last_name"
            class="contact-form-input"
            type="text"
            required
            v-model="form.last_name.value"
            @blur="validateField($event, form.last_name)"
          />
          <span
            class="invalid-feedback"
            v-if="form.last_name.errors.required"
          >Nazwisko nie może być puste</span>
        </div>

        <div class="form-group">
          <p class="contact-form-required-fields">* - Pola obowiązkowe</p>
        </div>

        <div class="form-group">
          <label for="subject" class="contact-form-label">Proszę wybrać temat</label>
          <select
            v-model="form.subject.value"
            id="subject"
            name="subject"
            class="contact-form-select contact-form-input"
          >
            <option v-for="subject in subjects" :value="subject">{{ subject }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="message" class="contact-form-label">Wiadomość</label>
          <textarea
            id="message"
            class="contact-form-input"
            rows="6"
            required
            v-model="form.message.value"
            @blur="validateField($event, form.message)"
          ></textarea>
          <span class="invalid-feedback" v-if="form.message.errors.required">Pole nie może być puste</span>
        </div>

        <div class="contact-prefer form-group">
          <label class="contact-form-label">Preferowana forma kontaktu</label>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="pEmail"
              v-model="form.prefer_email.value"
            />
            <label class="contact-form-label" for="pEmail">E-mail</label>
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="pPhone"
              v-model="form.prefer_phone.value"
            />
            <label class="contact-form-label" for="pPhone">Telefon</label>
          </div>

          <div class="contact-form-button">
            <button class="form-button" :disabled="!submittable" @click="submit" right>WYŚLIJ</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import { mapState } from "vuex";
import Form from "../form/src/Form";

export default {
  components: {},
  data() {
    return {
      form: Form.build({
        company_name: "",
        name: "",
        last_name: "",
        email: "",
        phone: "",
        subject: "Rejestracja nowego klienta",
        message: "",
        prefer_email: true,
        prefer_phone: true
      }),
      subjects: ["Rejestracja nowego klienta", "Jak kupować?", "Inny temat"],
      submitted: false,
      progress: false
    };
  },
  computed: {
    submittable() {
      return !this.progress && !this.submitted;
    }
  },
  methods: {
    ...Form.methods(),
    async submit(evt) {
      let data = this.validateForm(evt, this.form);
      if (data) {
        this.progress = true;
        this.submitted = true;
        await this.$store.dispatch("company/sendMessage", data);
        // this.$store.dispatch(
        //   "addSuccessNotification",
        //   "Wiadmość została wysłana"
        // );
        this.$store.dispatch("addNotification", {
          key: "contactForm",
          message: ""
        });
        this.progress = false;
        this.submitted = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/VetDirectBeforeLoginContact.vue